<template>
  <div>
  <el-dialog title="用户备注信息" :visible.sync="dialogVisible" @close='dialogFormVisible'  :close-on-click-modal="false"
    :close-on-press-escape="false">
      <div>
       
        <el-form size="small" :model="form">
           <el-form-item label="用户信息" :label-width="formLabelWidth">
             <div>
                <p>昵称：{{form.nickName}}</p>
                <p>手机：{{form.mobile}}</p>
              </div>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="content" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="" :label-width="formLabelWidth">
            <el-button type="primary" @click="addRemark" :loading="loading">提交</el-button>
          </el-form-item>
        
        </el-form>
      </div>
      <div  style="">
              <div style="width:100%;overflow-y:auto;">
                <el-timeline :reverse="reverse">
                  <el-timeline-item
                    v-for="(item, index) in tableData"
                    :key="index"
                    :timestamp="item.create_time">
                    <div class="d-b-c">
                      <div>{{item.content}}</div>
                      <el-button type="text" @click="delRemark(item)" >删除</el-button>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
             <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                background
                :current-page="curPage"
                :page-sizes="[20, 50, 100, 200, 300, 500]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalDataNumber"
              ></el-pagination>
            </div>
          </div>
    </el-dialog>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    components: {
    },
    data() {
      return {
        tableData:[],
        /*左边长度*/
        formLabelWidth: '80px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        curPage: 1,
        pageSize: 10,
        content: '',
        reverse: false,
      };
    },
    props: ['open_remark', 'form'],
    created() {
      this.dialogVisible = this.open_remark;
      console.log(this.dialogVisible)
      console.log(this.form)
      this.getData();
    },
    methods: {
        /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
      /*修改用户*/
      addRemark() {
        let self = this;
        self.loading = true;
        let params = {
          user_id:self.form.user_id,
          content:self.content,
        };
        if(!params.content){
          self.$message({
                message: '请填写内容给',
                type: 'error'
              });
              self.loading = false;
              return;
        }
        UserApi.remarkAdd(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.content = '';
              self.curPage = 1;
              self.getData();
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*删除*/
      delRemark(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          UserApi.remarkDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {}
          Params.user_id = self.form.user_id;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
          UserApi.remarkList(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
              // self.labelModel.catList = self.tableData;
            })
            .catch(error => {
              self.loading = false;
            });
        },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/UserRemark.vue